document.addEventListener('DOMContentLoaded', function() {
      
        const swiper = new Swiper('.flashing-words', {
      			  
			loop: true,
			pagination: false,
			autoplay: {
				delay: 900
			},
          
			slidesPerView: 1,
			speed: 500,
			slidesPerGroup: 1,
			effect: 'fade',
			  fadeEffect: {
				crossFade: true
			  }		  
			
		});	
});	